module.exports = __webpack_public_path__ + "static/Spring_2020_010-800x500-1a0a2ee7b6c8cccb21bd91b90925da14.jpg";